import axios from 'axios';
import { environment as env } from 'environments';
import LocalStorageService from 'services/LocalStorageService';

const USER_DATA = 'userData';
export const api = {
  baseURL: `${env.httpHost}`,
  flights: `${env.httpHost}/flights`,
  auth: `${env.httpHost}/auth/login`,
  extra: `${env.httpHost}/services/extra`,
  timestamps: `${env.httpHost}/timestamps/templates`,
};

export const axiosInstance = axios.create({
  baseURL: api.baseURL,
  responseType: 'json',
});

/**
 * Fresh unmodified Axios instance
 *
 * Should not connect any interceptors.
 * Should be used with third-party tools only
 */
export const thirdPartyAxiosInstance = axios.create({
  responseType: 'json',
});

export const refreshPermissions = () => {
  return axiosInstance
    .get('permissions')
    .then((res) => {
      const userData = LocalStorageService.getUserData();
      if (res && res.data) {
        const newPermisions = (res.data.permissions || '')
          .split(',')
          .map((i) => `${userData.station}-${i}`)
          .join(',');
        userData.permissions = newPermisions;
        LocalStorageService.setUserData(userData);
      }
      return userData || {};
    })
    .catch((e) => console.log(e));
};

axiosInstance.interceptors.request.use(
  function (config) {
    const jsonUserData = localStorage.getItem(USER_DATA);
    const { accessToken, station } =
      (jsonUserData && JSON.parse(jsonUserData)) || {};

    // When sending FormData (file uploads), let the browser set Content-Type
    // automatically so it includes the correct multipart boundary.
    const isFormData = config.data instanceof FormData;

    config.headers = {
      ...config.headers,
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      'X-Station': station,
      Authorization: accessToken,
    };

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let isHandlingUnauthorized = false;

const isUnauthorized = (error) =>
  error.status === 401 || (error.response && error.response.status === 401);

const isLoginPage = () => window.location.pathname === '/login';

const isPushUnsubscribeRequest = (error) =>
  (error.config?.url || '').includes('/messages/subscriptions');

axiosInstance.interceptors.response.use(
  function (response) {
    const userData = JSON.parse(localStorage.getItem(USER_DATA)) || {};
    const token = userData.accessToken;
    const headersToken = response.headers && response.headers.authorization;

    if (headersToken && token && headersToken !== token.split(' ')[1]) {
      userData.accessToken = `Bearer ${headersToken}`;
      localStorage.setItem(USER_DATA, JSON.stringify(userData));
      window.dispatchEvent(new Event('userdata-updated'));
      refreshPermissions();
    }
    return response;
  },
  function (error) {
    if (
      isUnauthorized(error) &&
      !isHandlingUnauthorized &&
      !isLoginPage() &&
      !isPushUnsubscribeRequest(error)
    ) {
      isHandlingUnauthorized = true;
      sessionStorage.setItem('logout-reload-pending', 'true');

      import('services/Auth').then(({ default: Auth }) => {
        Auth.signout(() => {
          localStorage.setItem('signOutNotification', JSON.stringify(true));
          window.location.replace('/login');
        });
      });
    }
    return Promise.reject(error);
  }
);
